import { render, staticRenderFns } from "./AlertDetailContainer.vue?vue&type=template&id=19a372e4&scoped=true&"
import script from "./AlertDetailContainer.vue?vue&type=script&lang=js&"
export * from "./AlertDetailContainer.vue?vue&type=script&lang=js&"
import style0 from "./AlertDetailContainer.vue?vue&type=style&index=0&id=19a372e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a372e4",
  null
  
)

export default component.exports